export function IsTruthy(value: any) {
  if (typeof value === "string") {
    value = value.toLowerCase();
    if (value === "true" || value === "1" || value === "yes") {
      return true;
    }
    return false;
  }
  if (typeof value === "number") {
    return value === 1;
  }
  return value === true;
}
